import {Type} from "../../../../../../interfaces/ui/uiInfo";

type Name = 'affiliation' | 'fullName' | 'pwz' | 'phone' | 'password' | 'repeatPassword' | 'workPlace';

export interface IFormData {
  name: Name;
  label: string
  type: Type;
  placeholder: string
  isRequired?: boolean
}

export const formDataViewing: IFormData[] = [
  {
    name: 'pwz',
    label: 'PWZ',
    type: 'number',
    placeholder: 'Wpisz PWZ...',
    isRequired: true
  },
  {
    name: 'affiliation',
    label: 'Afiliacja',
    type: 'text',
    placeholder: 'Wpisz tytuł naukowy...',
    isRequired: true
  },
  {
    name: 'fullName',
    label: 'Imię i Nazwisko',
    type: 'text',
    placeholder: 'Wpisz imię i nazwisko...',
    isRequired: true
  },
  {
    name: 'phone',
    label: 'Numer kontaktowy',
    type: 'number',
    placeholder: 'Wpisz swój numer telefonu...'
  },
  {
    name: 'password',
    label: 'Hasło',
    type: 'password',
    placeholder: 'Wpisz swoje hasło...',
    isRequired: true
  },
  {
    name: 'repeatPassword',
    label: 'Powtórz hasło',
    type: 'password',
    placeholder: 'Wpisz ponownie swoje hasło...',
    isRequired: true
  }
]